module.exports = __webpack_public_path__ + "static/media/fill_59@2x.9e2a8446.png";